import { EditorOutputProps } from 'ui-components';

/**
 * Checks if a node in the editor state is empty (contains no meaningful content)
 */
function isNodeEmpty(node: any): boolean {
  // Base case: text nodes with content are not empty
  if (node.type === 'text') {
    return !node.text || node.text.trim() === '';
  }

  // If node has no children, it's empty
  if (!node.children || node.children.length === 0) {
    return true;
  }

  // Check if all children are empty
  return node.children.every(isNodeEmpty);
}

/**
 * Checks if the editor state is empty (contains no meaningful content)
 */
export function isEditorEmpty(
  serializedContent?: EditorOutputProps['editor'],
): boolean {
  if (!serializedContent?.editorState?.root) return true;

  const rootNode = serializedContent.editorState.root;

  // If root has no children, it's empty
  if (!rootNode.children || rootNode.children.length === 0) {
    return true;
  }

  // Check if all root children are empty
  return rootNode.children.every(isNodeEmpty);
}
